import i18n from 'i18next'
export const createSmartT = (i18n) => {
	let currentLang = i18n.language
	i18n.on('languageChanged', (lng) => (currentLang = lng))

	const getTranslationRaw = (key) => {
		const keys = key.split('.')
		let value = i18n.store.data[currentLang]?.translation
		for (const k of keys) {
			if (!value || !(k in value)) return null
			value = value[k]
		}
		return typeof value === 'string' ? value : null
	}

	const getPlaceholderNames = (template = '') => {
		const matches = [...template.matchAll(/{{(.*?)}}/g)]
		return matches.map((m) => m[1])
	}

	const preprocessKey = (key) => {
		// const originalKey = key
		if (key.startsWith('__')) {
			key = key.replace(/^__\.??/, 'placeholders.')
		} else if (key.startsWith('_')) {
			const withoutUnderscore = key.slice(1)
			if (
				!withoutUnderscore.includes('%') &&
				!withoutUnderscore.includes('.')
			) {
				key = `entity.${withoutUnderscore}.single`
			} else if (!withoutUnderscore.includes('%')) {
				key = `entity.${withoutUnderscore}`
			}
		}
		// console.warn('preprocessKey', { originalKey, key })
		return key
	}

	const parseSmartKey = (inputKey, options = {}) => {
		const parts = inputKey.split('%')
		const stack = [...parts]
		const build = (rawKey) => {
			const key = preprocessKey(rawKey)
			const template = getTranslationRaw(key)
			if (!template) return i18n.t(key, options)

			const placeholders = getPlaceholderNames(template)
			const values = {}

			placeholders.forEach((ph) => {
				const nextKey = stack.shift()
				if (!nextKey) return
				values[ph] = build(nextKey)
			})

			return i18n.t(key, { ...options, ...values })
		}
		return build(stack.shift())
	}

	const smartT = (inputKey, options = {}) => {
		if (typeof inputKey !== 'string') return inputKey
		if (
			!inputKey.includes('%') &&
			!inputKey.startsWith('_') &&
			!inputKey.startsWith('__')
		) {
			return i18n.t(inputKey, options)
		}
		let toReturn = parseSmartKey(inputKey, options)

		// We need to remove the placeholders from the translation if they were not used, we should be able to use the text with out placeholders if we want
		if (toReturn.includes('{{')) {
			const keys = getPlaceholderNames(toReturn)

			keys.forEach((key) => {
				toReturn = toReturn.replace(`{{${key}}}`, '')
			})

			// Remove leading/trailing spaces first
			toReturn = toReturn.trim()

			// Remove double internal spaces
			toReturn = toReturn.replace(/\s+/g, ' ')

			// Capitalize first non-space letter
			toReturn = toReturn.charAt(0).toUpperCase() + toReturn.slice(1)
		}

		return toReturn
	}

	return smartT
}

export const smartT = createSmartT(i18n)
